export var queryType;
(function (queryType) {
    queryType["preLive"] = "preLive";
    queryType["live"] = "live";
    queryType["today"] = "today";
    queryType["personalized"] = "personalized";
})(queryType || (queryType = {}));
//# sourceMappingURL=requestTypes.js.map